import moment from 'moment';

export const getMinimumSendAt = () => moment().add(1, 'days').hours(12).minutes(0)
  .seconds(0)
  .milliseconds(0);

export const getDefaultExtraTouchSendAt = (currentTouchTrigger: any, nextTouchTrigger?: any) => {
  const currentSendAt = moment(currentTouchTrigger.sendAt);

  if (!nextTouchTrigger) {
    return currentSendAt.add(1, 'day').hours(12).minutes(0).seconds(0)
      .milliseconds(0)
      .toISOString();
  }

  const nextSendAt = moment(nextTouchTrigger.sendAt);
  const midpoint = currentSendAt.valueOf() + ((nextSendAt.valueOf() - currentSendAt.valueOf()) / 2);

  return moment(midpoint).hours(12).minutes(0).seconds(0)
    .milliseconds(0)
    .toISOString();
};
